
export type UUID = string; // RFC4122-compliant UUID string


// Ensure consistent .js extension for compatibility if needed, or remove if using TS resolution
export * from './Room'; // Exports SET_MAIN_VIEW_CONTENT, SetMainViewContentPayload
export * from './ParticipantPuppet'; // Exports the participant puppet (human wearing a companion avatar) contracts (#3837)
export * from './ParticipantExpression'; // Exports the puppet upper-face tracking packet (#3842)
export * from './RoomTime';
export * from './RoomDefinition';
export * from './RoomMode';
export * from './MarketOddsCard'; // #4401 prediction-market odds card face
export * from './RoomDefinitionBuilder';
export * from './ParticipationLayer';
export * from './ExternalParticipants';
export * from './CompanionRuntime';
export * from './NormalizedEvents';
export * from './Townhall';
export * from './VoiceActivities';
export * from './OwnItOrBluff';
export * from './Pallets';
export * from './TownhallAudience';
export * from './StageMedia'; // Exports shared stage-media capability types (youtube/hls/mp4)
export * from './StageFeedback'; // Exports shared stage feedback capability types (targeted reactions)
export * from './User';
export * from './ActivityModule';
export * from './WebSocketEvents'; // Exports SocketEvents enum
export * from './TTSService';
export * from './Session';
export * from './LLMConfigSchema'; // Assuming .js needed
export * from './TranscriptionConfig';
export * from './Agents'; // Exports ListeningState, AgentState (Assumption)
export * from './STTService';
export * from './SttVendorLink'; // Exports VendorLink: who holds the STT vendor connection
export * from './AvatarCompanion'; // Exports Avatar Companion types, schemas, and utilities
export * from './AvatarCompanionPhase1'; // Exports Phase 1 enhancements: expertise, personality, context, audit systems
export * from './AvatarManifest'; // Exports the avatar sidecar manifest: variant routing + face calibration (#3095)
export * from './AdminSystem'; // Exports Phase 2 admin system: roles, permissions, sessions, audit logging
export * from './PersonalityInferenceV3';
export { PrivacyLevel } from './PersonalityInferenceV3'; // Exports Phase 3 enhanced personality inference: zero-shot AI, multimodal analysis, real-time adaptive behavior
export * from './ComponentHealth'; // Exports component health monitoring, circuit breaker, and cleanup orchestration types
export * from './audioUtils'; // Exports shared audio utilities (ensureWavHeader)
export * from './TalkShowTopics'; // Exports talk show topic agenda, per-agent search cache types
export * from './TownhallDiagnostics'; // Exports classifyEventShape and RecognizedEventShape for shared Redis pub/sub diagnostics
export * from './HlsReadiness'; // Exports HLS manifest/media-object readiness metadata
export * from './PresentationCard'; // Exports room-agnostic presentation card types for dynamic presentation layer
export * from './HomepageExperience';
export * from './HomepageRoom';
export * from './TownhallBroadcast'; // Exports broadcast destination, session, and output types
export * from './TownhallRecording'; // Exports server-side MP4 recording types for MediaMTX playback API
export * from './ProgramParticipantMedia'; // Exports Program Publisher participant WHIP/WHEP ingest contracts
export * from './WebStage'; // Exports web stage types for external URL display capability
export * from './TownhallProgramManifest'; // Exports program manifest types for pre-built show programs
export * from './RoomProgram'; // Exports scheduled room program definitions, runs, and schedule math
export * from './CompanionPromptOverride'; // Exports host companion prompt override + adult-mode API types (#1663)
export * from './RoomCompanion'; // The host API for a room's companion definition: character, template, voice (#4632 phase 3c)
export * from './CuratedCompanionPrompts'; // The curated launch companion prompts as role + capability blocks (#3667)
export * from './CompanionTemplates'; // Approved mad-libs companion templates for the Avatar tab and the turn verdict
export * from './promptGenerator'; // Exports generateSystemPrompt + generatePromptPreview shared with web-next (#1663)
export * from './CompanionVision'; // Exports companion vision and gameplay-share spike contracts
export * from './WakeWords'; // Exports room companion wake-word helpers
export * from './HostPanel'; // Exports unified host panel modes, tabs, and capability contracts
export * from './Sixync'; // Exports Sixync protocol contracts for live-room state synchronization
export * from './SixyncReducer'; // Exports Sixync snapshot/event reducer helpers
export * from './CfbSync'; // Accepted CFB position and narration identity over Sixync

export * from "./ShareAudioEvidence";
export * from './GenTV';
export * from './GenTVV2';

export * from './PresentationBroadcast';
export * from './PresentationSelection';
export * from './Telestration';
export * from './ContextualVisual';
export * from './FootballCoachRead';
export * from './TvStagePreview';
export * from './TvPipSettings';
export * from './TvCameraDemand';
export * from './TvMusic';
export * from './TvMediaAudio';
export * from './TvRecovery';

export * from './RoomMusic';
export * from './RoomMusicDefaults';
export * from './MusicSpeech';
export * from './RoomMusicTimeline';
export * from './MusicNowPlaying';
export * from './MusicSync';
export * from './SongCard';

export * from './RoomClock';
export * from './LegalAcknowledgement'; // Exports legal acknowledgement + liability waiver contracts (#4301)
export * from './CompanionPip'; // Room-level companion PIP visibility (#4315)
export * from './RoomExperience'; // What a room is for: Game day, Game night, Hang out, Make a show (#4888)
export * from './RoomLinkSuggestions';
export * from './WebGameStage'; // Web Games: Play Together room state + shared URL rules (#4486)
export * from './ExternalGames'; // Web Games catalog: cards, modes, health (#4495)
export * from './WebGameSubmission'; // Public game submissions: schema, review shape (#4504)
export * from './WebGameLinkKey'; // One canonical link key per game (#4506)
export * from './MiniMoto'; // Mini Moto native race: room <-> game iframe contract (#4577)

export * from './SportsChallenge';

export * from './CharacterAvailability';
export * from './Tennis';
export * from './OwnedActivity';

export * from './PeerContinuity';
export * from './ParticipantPresence';

export * from './Holdem';

export * from './ActivityParticipantTiles'; // Activities that seat participants' video themselves: room dock + program layout (#4815)
export * from './GenTVRuntimeV2';

export * from './ContextualVisualStream';
export * from './drawing';
export * from './CompanionActions'; // companion body-action catalog + command matcher
